<template>
  <div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">Implementing Agency</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">Contact Person</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <ImplementingAgency v-on:emitForm1="goNextStep"></ImplementingAgency>
        </v-stepper-content>
        <template v-if="e1==2">
          <v-stepper-content step="2">
            <ContactPerson v-on:emitForm2="goNextStep" ref="agencyList"></ContactPerson>
          </v-stepper-content>
        </template>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");

import ImplementingAgency from "./step_forms/implementingAgency";
import ContactPerson from "./step_forms/impAgency_contactPerson";
export default {
  components: {
    ImplementingAgency,
    ContactPerson
  },
  data() {
    return {
      e1: 0
    };
  },
  created() {},
  methods: {
    goNextStep(num) {
      this.e1 = num;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/project_info/implement_agency/dataTable.vue